import {
    Collapse,
    useBoolean,
    useMediaQuery,
    useOutsideClick
} from '@chakra-ui/react'
import { Logo } from 'components/atoms'
import { Icon } from 'components/atoms/Icon'
import { media } from 'components/utils/breakpoints'
import { motion } from 'framer-motion'
import React, { useEffect } from 'react'
import { Navigation } from '../Navigation'
import { Container, SidebarBody, SidebarHeader } from './styles'

export const Sidebar: React.FC = () => {
    const ref = React.useRef(null)
    const [isLarger] = useMediaQuery(media('lg'))

    const [state, setState] = useBoolean(isLarger)
    useOutsideClick({
        ref: ref,
        enabled: state && !isLarger,
        handler: () => setState.off()
    })

    useEffect(() => {
        isLarger ? setState.on() : setState.off()
    }, [isLarger])

    const closeSidebar = () => {
        if (isLarger) {
            setState.off()
        }
    }

    return (
        <Container
            data-testid="sidebar"
            bg="white"
            shadow="md"
            open={state}
            as={motion.div}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
        >
            <SidebarHeader data-testid="sidebar-header" open={state} ref={ref}>
                <Icon
                    data-testid="sidebar-toggle"
                    name={`arrow-${state ? 'left' : 'right'}`}
                    onClick={setState.toggle}
                />
            </SidebarHeader>

            <SidebarBody ref={ref} data-testid="sidebar-body">
                <Collapse startingHeight={27} in={state} animateOpacity>
                    <Logo
                        type={state ? 'default' : 'default-sm'}
                        maxW={state ? '150px' : '27px'}
                        height={state ? '36px' : '27px'}
                    />
                </Collapse>
                <Navigation redirect={closeSidebar} isOpen={state} />                                   
            </SidebarBody>
        </Container>
    )
}
